import styles from './style/ImagePreview.module.css';

type Props = {
  url: string;
};

export const ImagePreview = ({ url }: Props) => {
  console.log(url);

  return (
    <div className={styles.root}>
      <img
        className={styles.img}
        crossOrigin="anonymous"
        src={url} />
    </div>
  );
};

export default ImagePreview;